import unzip from 'unzip-js'

export const unzipFile = file => {
  return new Promise((resolve, reject) => {
    unzip(file, (err, zipFile) => {
      if (err) {
        reject(err)
      } else {
        resolve(zipFile)
      }
    })
  })
}

export const blobToDataUrl = blob => URL.createObjectURL(blob)

export const fileToBlob = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    // Read the file as an array buffer
    reader.onloadend = () => {
      const arrayBuffer = reader.result
      const blob = new Blob([arrayBuffer], { type: file.type })
      resolve(blob) // Resolve the blob
    }

    reader.onerror = () => {
      reject(new Error('Error reading file.'))
    }

    reader.readAsArrayBuffer(file) // Read the file
  })
}

export const fileToDataUrl = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
    reader.readAsDataURL(file)
  })
}

const loadZipFile = async file => unzipFile(await fileToBlob(file))

export const getPdfUrlFromPkg = async file => {
  return new Promise((resolve, reject) => {
    if (file?.name.endsWith('.pkg')) {
      loadZipFile(file)
        .then(zipFile => {
          let found = false
          zipFile.readEntries((err, entries) => {
            if (err)
              reject(new Error(`Error reading zip files: ${err.message}`))

            entries.forEach(entry => {
              if (
                entry.name.startsWith('Reports/') &&
                entry.name.endsWith('.pdf')
              ) {
                found = true
                zipFile.readEntryData(
                  entry,
                  false,
                  (entryError, readStream) => {
                    if (err)
                      reject(
                        new Error(
                          `Error reading zip file: ${entryError.message}`,
                        ),
                      )

                    const chunks = []
                    readStream.on('error', streamError => {
                      reject(
                        new Error(
                          `Error reading zip file ${entry.name}: ${streamError.message}`,
                        ),
                      )
                    })
                    readStream.on('data', chunk => {
                      chunks.push(chunk)
                    })
                    // eslint-disable-next-line consistent-return
                    readStream.on('end', () => {
                      const blob = new Blob(chunks, {
                        type: 'application/pdf',
                      })
                      const url = URL.createObjectURL(blob)
                      resolve(url)
                    })
                  },
                )
              }
            })
            if (!found)
              reject(new Error('Pkg file does not contain a pdf file.'))
          })
        })
        .catch(err => {
          reject(new Error(`Error unzipping file: ${err.message}`))
        })
    } else {
      reject(new Error('Please select a valid PKG file.'))
    }
  })
}

export const fetchBlobToDataUrl = url => {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader()
        reader.onloadend = () => {
          resolve(reader.result)
        }
        reader.onerror = () => {
          reject(new Error('Error reading blob as data URL.'))
        }
        reader.readAsDataURL(blob)
      })
      .catch(err => {
        reject(new Error(`Error fetching blob: ${err.message}`))
      })
  })
}

export const dataURLToFile = (dataURL, fileName) => {
  const arr = dataURL.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  // eslint-disable-next-line no-plusplus
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], fileName, { type: mime })
}
